export const calculatePercentageChange = (
  value1: number,
  value2: number,
): number => {
  if (value1 === 0) {
    throw new Error("Cannot calculate percentage change from 0");
  }
  return Math.round(Math.abs(((value2 - value1) / value1) * 100));
};
